import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEditPageComponent} from "./custom-object-edit-page.component";
import {ProductLineCustomObjectEntityModel} from "../product-line-custom-object-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-product-line-custom-object-edit-page",
    templateUrl: "./custom-object-edit-page.component.html",
    providers: [provideEntityModel(ProductLineCustomObjectEntityModel)]
})
export class ProductLineCustomObjectEditPageComponent extends CustomObjectEditPageComponent {
    override productLineContext: boolean = true;

    constructor(model: ProductLineCustomObjectEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
